import classNames from 'classnames';
import React, {ReactNode} from 'react';

import {ROLES} from './Menu';

interface Props {
  children: ReactNode;
  className?: string;
  // Specify when component is being used in a list
  itemKey?: string;

  // Do not define `_role` -- this is used internally by the component.
  _role: string;
}
/**
 * Renders a section header in a Menu. See Menu implementation.
 *
 * <Section>
 *   <SectionHeader>Section Header</SectionHeader>
 *   <Option>Option 2</Option>
 * </Section>
 */
// eslint-disable-next-line react/prefer-stateless-function -- using a class component in order to preserve _role on defaultProps
export default class SectionHeader extends React.Component<Props> {
  static defaultProps = {
    _role: ROLES.SECTION_HEADER,
  };

  override render(): JSX.Element {
    return (
      <li key={this.props.itemKey} className={classNames('menu-sectionHeader', this.props.className)}>
        {this.props.children}
      </li>
    );
  }
}
